module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.offergroup', {
            url: '/offergroup/{offerNumber}?{name}&{productId:int}&{cardId:int}&{pageNumber:int}&{filters}&{sortby}',
            resolve: {
                deps: ['$$animateJs', '$ocLazyLoad', function ($$animateJs, $ocLazyLoad) {
                    return $ocLazyLoad.load(window.wowModules[8].files[0]);
                }]
            },
            data: {
                showBothPanelsInSmallFormat: true,
                noIndex: true,
                analytics: `bws:web:offergroup`
            },
            views: {
                'left-panel@': {
                    template: '<wow-filters-mobile></wow-filters-mobile>'
                },
                'center-panel@': {
                    template: '<bws-offer-group></bws-offer-group>'
                },
                'dynamic-content-top@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule class="dynamic-content2-panelTop"></oly-dynamic-content>'
                },
                'dynamic-content-bottom@': {
                    template: '<oly-dynamic-content oly-dc-url-schedule="bottom" class="dynamic-content2-panelBottom"></oly-dynamic-content>'
                },
                '': {
                    template: '<oly-sticky-header-with-text ng-if="breakpointsService.isInSmallFormat" ng-show="showHeader"></oly-sticky-header-with-text>'
                },
                'aem-view@': {
                    template: '<wow-aem-portal project="generic" is-partial="true"></wow-aem-portal>'
                }
            }
        });
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/routes/offergroup.js
 **/